export default {
    THE1_FORM: {
        TELEPHONE: ["เบอร์โทรศัพท์มือถือ", "Mobile Phone"],
        CARD_NO: ["หมายเลขสมาชิก The 1", "The 1 Member No."],
        NATIONAL_ID: ["หมายเลขบัตรประชาชน", "Thai National ID."],
        MEMBER_NAME: ["ชื่อสมาชิก", "Member Name"],
        VERIFY: ["ตรวจสอบ", "Verify"],
        CONFIRM: ["ตกลง", "Confirm"],
        CANCEL: ["ยกเลิก", "Cancel"],
        REMOVE_CARD: ["ยกเลิก", "Remove Card"]
    },
    THE1_REGISTER: {
        HEADER: ["ระบบลงทะเบียนโอนคะแนน", "Trasfering Points Registration Form"],
        INSTRUCTION: {
            HEADER: ["ขั้นตอนการลงทะเบียนโอนคะแนน", "Registration Instructions"],
            STEP1: ["1. หากคุณลูกค้ายังไม่เป็นสมาชิก The 1 คุณลูกค้าสามารถลงทะเบียน", "1. If you are not The 1 member, please register before fill this form"],
            STEP2: ["2. กรอกแบบฟอร์มให้ถูกต้องและกดยืนยัน บิวเทรี่ยมขอสงวนสิทธิในการโอนคะแนนเฉพาะผู้ที่ให้ข้อมูลถูกต้องเท่านั้น", "2. Fill and submit the form below with correct information. BEAUTRIUM reserves the right to reject transfering points to those who did not complete the form."],
            STEP3: ["3. คะแนนสะสมจะถูกโอนไปยัง The 1 ไม่เกิน 45 วันทำการค่ะ", "3. The points will be transferred within 45 working days."],
        },
        USER_PROFILE: ["ข้อมูลลูกค้า", "Profile"],
        FIRST_NAME: ["ชื่อ", "First Name"],
        LAST_NAME: ["นามสกุล", "Last Name"],
        DOB: ["วันเกิด", "Date of Birth"],
        EMAIL: ["อีเมลล์", "Email"],
        TEL: ["เบอร์โทรศัพท์มือถือ", "Mobile Phone"],
        IDCARD: ["หมายเลขประจำตัวประชาชน", "ID Card No. / Passport No."],
        ADDRESS: ["ที่อยู่ (บ้านเลขที่, อาคาร, ซอย, ถนน)", "Contacting Address (House Number, Building Name, Road)"],
        POSTCODE: ["หมายเลขไปรษณีย์ (เพื่อค้นหาที่อยู่)", "Postal Code"],
        SUBDISTRICT: ["แขวง / ตำบล", "Subdistrict"],
        DISTRICT: ["เขต / อำเภอ", "District"],
        PROVINCE: ["จังหวัด", "Province"],
        COUNTRY: ["ประเทศ", "Country"],
        ATTACH_COPY: ["แนบสำเนาบัตรประชาชน", "Please attach copy of ID Card or Passport"],
        RECEIPT_ID: ["หมายเลขใบเสร็จ", "Receipt ID"],
        RECEIPT_AMOUNT: ["ยอดใบเสร็จ", "Receipt Amount"],
        RECEIPT: ["รูปถ่ายใบเสร็จ", "Receipt Image"],
        SUBMIT: ["ยืนยัน", "Submit"],
        RESPONSE: {
            SUCCESS: {
                HEADER: ["ลงทะเบียนเสร็จสิ้น", "Registration Completed"],
                MESSAGE: ["ได้รับข้อมูลของคุณลูกค้าเรียบร้อยค่ะ ทางบิวเทรี่ยมขอขอบพระคุณลูกค้าที่ไว้วางใจและเป็นลูกค้าบิวเทรี่ยมมาตลอดนะคะ", "We received your information. On behalf of BEAUTRIUM, we thank you for being our valued customer and always support us."]
            },
            FAILED: {
                HEADER: ["ลงทะเบียนไม่สำเร็จ", "Registration Failed"],
                MESSAGE: ["เกิดข้อผิดพลาด โปรดลองอีกครั้ง หรือ หากพบปัญหาใด ๆ โปรดแจ้งพนักงานสาขาหรือโทร 02-252-3653 ติดต่อ 101 ค่ะ", "Something went wrong. Please try again later and if the problem is occurred, don't be hesitate to contact us via storefront or tel. 02-252-3653 ext. 101"]
            }
        }

    }
}